module.exports = __webpack_public_path__ + "img/001.d3f9d29f.jpg";